import { useQuery } from '@tanstack/react-query';
import { bookingsApi } from './bookings.api';

export function useBookings(filter: 'today' | 'week' | 'upcoming' | 'past' | 'all') {
  return useQuery({
    queryKey: ['bookings.me', filter],
    queryFn: async () => {
      const resp = await bookingsApi.list(filter);
      return resp || [];
    },
    refetchInterval: 60000, // 60 seconds
  });
}
